import { FormProvider } from '@slal/ui/react-hook-form/core';
import { Field, FieldSet, RadioFieldGroup } from '@slal/ui/react-hook-form/fields';
import { Article, Heading, P, Text } from '@slal/ui/typography';
import { MaxWidthContent, Notification, StyledForm, yesOrNoOptions } from '~/components';
import { ApplicationButtons } from '~/features';
import { SelectedYesNoContent } from './SelectedYesNoContent';
import { useKeyConsiderationsApplicationForm } from './hooks';

const YesContent = () => {
    return (
        <Article>
            <Heading level={5}>Did you know these may be affected by this withdrawal?</Heading>
            <P markdown>
                We don't want you to be financially worse off when it comes to accessing your money. Each state benefit
                has its own criteria for means-testing. Check if this could be a problem for you before going ahead.
                [MoneyHelper](https://www.moneyhelper.org.uk/en/benefits/benefits-in-later-life/benefits-in-retirement?source=mas)
                can help.
            </P>
            <Notification level="info">
                <P>Some benefits could be affected when you start to take your pension benefits.</P>
                <P>
                    <Text tag="strong">Please call us on 0345 266 8013 to discuss</Text>. Call charges will vary.
                </P>
            </Notification>
        </Article>
    );
};

const NoContent = () => {
    return (
        <Article>
            <Heading level={5}>Thanks, that makes things easier.</Heading>
            <P markdown>
                If you start to receive means-tested benefits at any point in the future, be aware that withdrawing from
                your pension may affect your entitlement to these. The
                [MoneyHelper](https://www.moneyhelper.org.uk/en/benefits/benefits-in-later-life/benefits-in-retirement?source=mas)
                can help.
            </P>
        </Article>
    );
};

export const MeansTestedBenefitsForm = () => {
    const { form, handleSubmit, name, option } = useKeyConsiderationsApplicationForm(
        'meansTestedBenefits',
        '/application/key-considerations/continue-contributing'
    );

    return (
        <MaxWidthContent>
            <FormProvider {...form}>
                <StyledForm onSubmit={handleSubmit}>
                    <FieldSet aria-label="Means tested benefits">
                        <Field errorFor={name}>
                            <RadioFieldGroup name={name} options={yesOrNoOptions} stacked />
                        </Field>
                    </FieldSet>
                    {option && (
                        <SelectedYesNoContent option={option} YesContent={<YesContent />} NoContent={<NoContent />} />
                    )}
                    <ApplicationButtons backTo="/application/key-considerations/outstanding-debts" />
                </StyledForm>
            </FormProvider>
        </MaxWidthContent>
    );
};
